var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3238 7.9787C11.4228 6.25582 6.63741 6.0974 3.86799 6.93805C3.42327 7.07292 2.95298 6.82187 2.81821 6.37715C2.68344 5.93222 2.93428 5.46225 3.37932 5.32705C6.55842 4.36195 11.8433 4.54842 15.1831 6.53095C15.5831 6.76835 15.7143 7.28497 15.4772 7.68433C15.2399 8.08434 14.7229 8.21621 14.3238 7.9787ZM14.2288 10.5305C14.0253 10.8608 13.5935 10.9644 13.2636 10.7616C10.845 9.27491 7.15693 8.84427 4.29551 9.71275C3.92441 9.82495 3.53247 9.6157 3.41984 9.24536C3.30796 8.87426 3.51731 8.48306 3.88766 8.37022C7.1565 7.37836 11.2201 7.85876 13.998 9.56584C14.3278 9.76896 14.4316 10.2011 14.2288 10.5305ZM13.1276 12.9812C12.9658 13.2464 12.6205 13.3295 12.3563 13.1679C10.2427 11.8762 7.58262 11.5845 4.44984 12.3C4.14795 12.3692 3.84714 12.1801 3.77825 11.8782C3.70915 11.5764 3.89754 11.2755 4.20018 11.2066C7.6284 10.4229 10.5692 10.7602 12.9414 12.2097C13.2059 12.3713 13.2892 12.7168 13.1276 12.9812ZM9.00005 0C4.02952 0 0 4.02944 0 8.99989C0 13.9709 4.02952 18 9.00005 18C13.9707 18 18 13.9709 18 8.99989C18 4.02944 13.9707 0 9.00005 0Z",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotify);
export default __webpack_public_path__ + "static/media/Spotify.874b7555e67aa9ea00f3ceab157eff15.svg";
export { ForwardRef as ReactComponent };